// extracted by mini-css-extract-plugin
export default {"message":"message_ncyxG","row":"row_YJppk","col":"col_YtMO5","sideMenu":"sideMenu_c0UmL"};